import React from 'react';
import PropTypes from 'prop-types';
import MuiTabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/system';
import {
  getMenuItemNamesTypography,
  getHeaderAccentMain
} from 'styles/helpers/getThemeStyles';

const StyledTabs = styled(MuiTabs)(({ theme }) => ({
  color: theme.palette.sectionNav.link.main,
  '& .MuiTabs-indicator': {
    backgroundColor: getHeaderAccentMain(theme)
  }
}));

const StyledTab = styled(Tab)(({ theme }) => {
  const styles = getMenuItemNamesTypography(theme);
  return {
    '&:hover': {
      color: theme.palette.sectionNav.link.hover,
      opacity: 1
    },
    '&.Mui-selected': {
      '&:hover': {
        color: theme.palette.sectionNav.link.hover
      }
    },
    ...styles
  };
});

const Tabs = ({ tabLabels, activeTab = 0, handleTabClick }) => {
  return (
    <StyledTabs value={activeTab} indicatorColor="primary" textColor="inherit">
      {tabLabels.map(tab => {
        return (
          <StyledTab
            key={tab}
            data-testid={`${tab}-option-tab`}
            label={tab}
            onClick={() => handleTabClick(tab)}
          />
        );
      })}
    </StyledTabs>
  );
};

Tabs.propTypes = {
  tabLabels: PropTypes.array.isRequired,
  activeTab: PropTypes.number.isRequired,
  handleTabClick: PropTypes.func.isRequired
};

export default Tabs;
